export default __webpack_public_path__ + "static/lk-853b4c532f4f09f5f74a722be8515785.svg";